module.exports = __webpack_public_path__ + "static/img/文字背景.4659b00b.png";